var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication1Line37(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Communication_1-line-37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 12.5h-1.7v-1.5c0-5.9-4.4-10.5-10-10.5h-1c-5.6 0-10 4.6-10 10.5v1.5h-1.7c-1.25 0-2.3 1.050-2.3 2.3v5.4c0 1.25 1.050 2.3 2.3 2.3h4.7v-10h-2v-1.5c0-5.35 3.95-9.5 9-9.5h1c5.050 0 9 4.15 9 9.5v1.5h-2v10h2c-0.25 4.95-3.8 5.8-5.050 5.95-0.25-1.1-1.25-1.95-2.45-1.95h-2c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5h2c1.2 0 2.25-0.9 2.45-2.050 1.45-0.15 5.8-1.15 6.050-6.95h1.7c1.25 0 2.3-1.050 2.3-2.3v-5.4c0-1.25-1.050-2.3-2.3-2.3zM7.5 21.5h-3.7c-0.7 0-1.3-0.6-1.3-1.3v-5.4c0-0.7 0.6-1.3 1.3-1.3h3.7v8zM18 30.5h-2c-0.85 0-1.5-0.65-1.5-1.5s0.65-1.5 1.5-1.5h2c0.85 0 1.5 0.65 1.5 1.5s-0.65 1.5-1.5 1.5zM29.5 20.2c0 0.7-0.6 1.3-1.3 1.3h-3.7v-8h3.7c0.7 0 1.3 0.6 1.3 1.3v5.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication1Line37);
export default __webpack_public_path__ + "static/media/Communication_1-line-37.ace41d27ebfd8d7ae46ff36948af3426.svg";
export { ForwardRef as ReactComponent };